Namespace 'Monitoring.Previews'

class Monitoring.Previews.FacebookPostPreviewView extends Backbone.View
  className: 'post-preview'
  template: JST['backbone/templates/monitoring/previews/facebook_post_preview']

  initialize: (@options = {}) ->
    # just set @options

  render: ->
    @gotPost = true
    if @options.post
      @renderPreview(@options.post)
    else
      @fetchContent()

  fetchContent: =>
    @gotPost = false
    url = '/previews/fetch_full_content'
    $.post(url, {id: [@options.id]}, (response) =>
      return if response == null
      @renderPreview(response)
    )

  renderPreview: (post) => 
    @gotPost = true
    @$el.html(@template(post: post, campaign: false))

  readyToRender: =>
    @gotPost